module.exports = __webpack_public_path__ + "static/media/front-direct-image-1.0e773a34.png";